import React from 'react';
import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAutoRefresh } from '../contexts/AutoRefreshContext';

export default function AutoRefreshToggle() {
  const { enabled, toggle, secondsLeft } = useAutoRefresh();
  const { t } = useTranslation();

  return (
    <button
      onClick={toggle}
      className={`flex items-center gap-1.5 px-2 py-1 rounded-md border text-xs font-medium transition-colors ${
        enabled
          ? 'border-blue-400 dark:border-blue-500 bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400'
          : 'border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-600'
      }`}
      title={enabled ? t('ui.autoRefreshOn') : t('ui.autoRefreshOff')}
    >
      <RefreshCw className={`w-3 h-3 ${enabled ? 'animate-spin' : ''}`} style={enabled ? { animationDuration: '3s' } : undefined} />
      {enabled && <span>{secondsLeft}s</span>}
    </button>
  );
}
